import LocalSettingsProto from "../../gd/settings/local-settings/local-settings-v4";


export default class ViewLocalSettings<SettingsClass> extends LocalSettingsProto {

    protected _appSettings?     : SettingsClass

    constructor(localStorageKey:string) {
        super(localStorageKey)

        const values        = this._readFromLocalStorage()

        this._appSettings      = _.get(values, 'appSettings', undefined)
    }

    get appSettings() {
        return this._appSettings
    }

    set appSettings(value:any) {
        this._appSettings = value
        this.save()
    }

    // toObject() {
    //     return {
    //         weekView            : this.weekView,
    //         displayItemsTypes   : this.displayItemsTypes,
    //         inboxGroupByDay     : this.inboxGroupByDay,
    //     };
    // }
}
